import { MitsIconModule } from '../mits-icon/mits-icon.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { MitsFilterButtonComponent } from './mits-filter-button.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, MitsIconModule],
  declarations: [MitsFilterButtonComponent],
  entryComponents: [MitsFilterButtonComponent],
  exports: [MitsFilterButtonComponent],
  providers: [],
})
export class MitsFilterButtonModule {}
